import { cn, tv } from '@pcln/horizon'
import type { PackageFormTripType } from '../types'

const packagesFormSlots = {
  gridContainer: [
    'grid grid-cols-1 gap-3 items-center mx-auto',
    'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]'
  ],
  radioButtons: 'text-nowrap [grid-area:options]',
  originInput: '[grid-area:origin]',
  destinationInput: '[grid-area:destination]',
  timelineInput: '**:translate-y-0 [grid-area:timeline]',
  passengersInput: '**:translate-y-0 [grid-area:passengers]',
  advancedSearchSlot: '[grid-area:advanced] flex items-center gap-2 py-2',
  checkBoxSlot: '[grid-area:checkbox] py-2',
  partStaySlot: '**:translate-y-0 [grid-area:partStay]',
  carPickupSlot: [
    '[grid-area:carPickup]',
    'grid gap-3 grid-cols-2 sm:grid-cols-4 lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr]',
    "[grid-template-areas:'city_city'_'pickupDate_pickupTime'_'dropoffDate_dropoffTime']",
    "sm:[grid-template-areas:'city_city_city_city'_'pickupDate_pickupTime_dropoffDate_dropoffTime']",
    "lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  ]
}

const packagesTypeVariants = {
  hotelWithFlight: {
    gridContainer: [
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'group_group_group_group_group']"
    ]
  },
  hotelWithFlightPartStay: {
    gridContainer: [
      'lg:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'partStay'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_partStay_partStay_partStay'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_destination_destination_timeline_timeline'_'partStay_partStay_passengers_passengers_submit_submit'_'group_group_group_group_group_group']"
    ]
  },
  hotelWithFlightWithCar: {
    gridContainer: [
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'group_group_group_group_group']"
    ]
  },
  hotelWithFlightWithCarPartStay: {
    gridContainer: [
      'lg:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'partStay'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_partStay_partStay_partStay'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_destination_destination_timeline_timeline'_'partStay_partStay_passengers_passengers_submit_submit'_'group_group_group_group_group_group']"
    ]
  },
  flightWithCar: {
    gridContainer: [
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'group_group_group_group_group']"
    ]
  },
  hotelWithCar: {
    gridContainer: [
      'lg:grid-cols-[1fr_1fr_1fr_max-content]',
      "[grid-template-areas:'options'_'destination'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_destination_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options'_'destination_timeline_passengers_submit'_'group_group_group_group']"
    ]
  },
  hotelWithCarPickupElsewhere: {
    gridContainer: [
      'lg:grid-cols-[1fr_1fr_1fr_1fr_1fr_.25fr]',
      "[grid-template-areas:'options'_'destination'_'timeline'_'passengers'_'checkbox'_'carPickup'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_destination_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'carPickup_carPickup_carPickup_carPickup_carPickup_carPickup'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_timeline_timeline_passengers_passengers'_'carPickup_carPickup_carPickup_carPickup_carPickup_submit'_'group_group_group_group_group_group']"
    ]
  }
}

type PackagesTypeVariants = keyof typeof packagesTypeVariants

export const horizonPackagesForm = tv({
  slots: packagesFormSlots,
  variants: {
    packagesType: packagesTypeVariants
  }
})

const getPackagesTypeVariant = (
  packagesType: PackageFormTripType,
  isHotelPartialStay: boolean,
  isCarPickupElsewhere: boolean
): PackagesTypeVariants => {
  if (packagesType === 'STAY:FLY:DRIVE') {
    if (isHotelPartialStay) {
      return 'hotelWithFlightWithCarPartStay'
    }
    return 'hotelWithFlightWithCar'
  }
  if (packagesType === 'FLY:DRIVE') {
    return 'flightWithCar'
  }
  if (packagesType === 'STAY:DRIVE') {
    if (isCarPickupElsewhere) {
      return 'hotelWithCarPickupElsewhere'
    }
    return 'hotelWithCar'
  }
  if (isHotelPartialStay) {
    return 'hotelWithFlightPartStay'
  }
  return 'hotelWithFlight'
}
export const getGridContainerClass = (
  packagesType: PackageFormTripType,
  isHotelPartialStay: boolean,
  isCarPickupElsewhere: boolean
) => {
  const packagesTypeVariant = getPackagesTypeVariant(
    packagesType,
    isHotelPartialStay,
    isCarPickupElsewhere
  )
  const styles = horizonPackagesForm({ packagesType: packagesTypeVariant })

  return cn(styles.gridContainer(), packagesTypeVariant)
}
